<div class="flex flex-col justify-between items-center rounded-md shadow-full w-full h-full py-4 overflow-hidden">

  <!-- Title and List -->
  <div class="flex flex-col justify-start items-center w-full h-full overflow-hidden">
    <!-- Title row -->
    <div class="flex flex-row w-full justify-between px-6 pt-2 pb-6">
      <span class="text-base text-gray-900 font-medium select-none">Alle Chats</span>
      <div class="flex flex-row justify-center items-center pt-1.5 w-4 h-4 hover:cursor-pointer" (click)="closeAllChatsView()">
        <fa-icon [icon]="faPlus" [transform]="'rotate-45'" class="text-base text-gray-900"></fa-icon>
      </div>
    </div>
    <!-- All chats list -->
    <table class=" block w-full max-w-full table-fixed max-h-full overflow-y-scroll overflow-x-hidden !bg-[#FFFFFF]">
      <tbody class="w-full h-full block">
        @for (chat of getChatList(); track chat; let i = $index) {
          @if (!renameChat[i]) {
            <tr (click)="selectChat(chat)" (mouseenter)="hovering[i] = true" (mouseleave)="onMouseLeave(i)"
              [attr.data-chat-row]="i" [ngClass]="{'bg-gray-200': chat.id == getCurrentChat()?.id, 'hover:cursor-pointer': hovering[i]}"
              class="flex flex-row justify-end items-center hover:bg-gray-100  text-gray text-sm pl-4 pr-6">
              <p [title]="chat.topic" class="text-gray text-ellipsis text-nowrap whitespace-nowrap break-normal overflow-hidden w-full px-2 py-2">
                {{ chat.topic }}
              </p>
              @if (hovering[i]) {
                <div (click)="$event.stopPropagation(); openDropdownAt(i)" [bicDropdownTrigger]="allChatsDropdown"
                     class="p-2">
                  <fa-icon [icon]="faEllipsisVertical"
                           class="h-full text-gray-900 flex flex-row justify-center items-center rounded-md">
                  </fa-icon>
                  <bic-dropdown #allChatsDropdown [dropdownPlacement]="'bottom-start'">
                    <bic-dropdown-element (click)="chat.id !== getCurrentChat()?.id && togglePinChat(chat); $event.stopPropagation()"
                      class="w-full text-sm">
                      @if(false) { <!-- condition here should check if chat is not yet pinned -->
                        <fa-icon [icon]="faThumbtack" class="text-gray-900 pr-3 pl-1"></fa-icon>
                        Anpinnen
                      } @else { <!-- here chat is already pinned -->
                        <fa-icon [icon]="faThumbtackSlash" class="text-gray-900 pr-3 -ml-1"></fa-icon>
                        Lösen
                      }
                    </bic-dropdown-element>
                    <bic-dropdown-element
                      (click)="chat.id !== getCurrentChat()?.id && selectChat(chat); renameChat[i]=true; $event.stopPropagation()"
                      class="w-full text-sm">
                      <fa-icon [icon]="faPenToSquare" class="text-gray-900 pr-3"></fa-icon>
                      Umbenennen
                    </bic-dropdown-element>
                    <bic-dropdown-element (click)="deleteChat(chat); $event.stopPropagation()"
                                          class="w-full text-sm">
                      <fa-icon [icon]="faTrash" class="text-gray-900 pr-3"></fa-icon>
                      Löschen
                    </bic-dropdown-element>
                  </bic-dropdown>
                </div>
              }
            </tr>
          }
          @if (renameChat[i]) {
            <tr class="flex relative items-center">
              <input
                #renameTopic
                (focus)="topicInputIsFocused = true; renameTopic.select()"
                (focusout)="topicInputIsFocused = false"
                [(ngModel)]="chat.topic"
                [placeholder]="chat.topic"
                autofocus
                class="block w-full p-2 ps-2 pe-[72px] text-sm text-gray border-2 border-gray-700 focus:border-gray focus:shadow-lg rounded-lg focus:outline-none overflow-ellipsis focus:ring-0"
                required
                type="text"
              />
              <button (click)="renameChat[i] = false"
                      class="absolute end-11 text-gray-300 hover:text-red focus:outline-none font-medium rounded-lg text-base"
                      type="submit">
                <fa-icon [icon]="faXmark" class="text-inherit text-lg"></fa-icon>
              </button>
              <button (click)="chatService.renameTopicTo('classic', renameTopic.value); renameChat[i]=false"
                      class="absolute end-4 text-gray-300 hover:text-green items-center focus:outline-none font-medium rounded-lg text-base"
                      type="submit">
                <fa-icon [icon]="faCheck" class="text-inherit text-lg"></fa-icon>
              </button>
            </tr>
          }
        }

      <!-- Load More Button -->
        @if (canLoadMore()) {
          <tr
            class="flex flex-row justify-center items-center hover:bg-gray-100 border border-gray-200 text-gray text-sm px-2">
          <button
            (click)="loadMoreChats()"
            [disabled]="isLoadingMore"
            class="w-full px-2 py-2 text-gray-600 hover:text-gray-800 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2">
            <fa-icon
              [icon]="isLoadingMore ? faSpinner : faArrowDown"
              [class.fa-spin]="isLoadingMore"
              class="text-sm">
            </fa-icon>
            @if (!isLoadingMore) {
              <span>Mehr laden</span>
            }
            @if (isLoadingMore) {
              <span>Lädt...</span>
            }
          </button>
        </tr>
        }
      </tbody>
    </table>
  </div>

  <!-- Footer with delete all and close buttons -->
  <div class="flex flex-row justify-end items-center w-full gap-4 px-6 pt-4">
    <bic-button (click)="deleteAllChats()" buttonType="white">
      <fa-icon iconLeft [icon]="faTrash" class="text-red-600"></fa-icon>
      <span class="text-red-600">Alle löschen</span>
    </bic-button>
    <bic-button (click)="closeAllChatsView()" buttonType="white">Schließen</bic-button>
  </div>

</div>
